import * as React from 'react'
import { errorToast } from 'src/utils/error-toast'
import { exceptions } from 'src/utils/exceptions'

type Props = {
  children: React.ReactNode
  fallback?: React.ReactNode
}

type State = {
  hasError: boolean
}

const DefaultFallback = () => (
  <div className="p-4 text-sm text-grey-700">
    We couldn&apos;t load the menu. Please{' '}
    <button
      className="text-blue-600 underline"
      type="button"
      onClick={() => window.location.reload()}
    >
      refresh the page
    </button>
    .
  </div>
)

export class SideNavErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    exceptions.handle(error, {
      params: {
        componentStack: errorInfo.componentStack,
        errorBoundary: 'SideNavErrorBoundary',
      },
      tags: { error_boundary: 'side_nav' },
    })
    errorToast(
      'We hit a problem loading the menu. Please refresh the page to retry.'
    )
  }

  render() {
    if (this.state.hasError) return this.props.fallback ?? <DefaultFallback />
    return this.props.children
  }
}
